import React, {PropTypes} from 'react';
import Switch from '../Switch/Switch';

const UploadedView = (props) => {

    const renderHeader = () => {
        return props.type === 'app' ? renderAppHeader() : renderDashboardHeader();
    };

    const renderAppHeader = () => {
        return (
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
            <div className="MU_logotype--uploaded__title">{props.text}:</div>
            <Switch value={props.activeElement} onChange={props.onActiveChange}/>
        </div>

        )
    }

    const renderDashboardHeader = () => {
        return ( <div className="MU_logotype--uploaded__title">{props.text}:</div>)
    }

    return (
    <div className="MU_logotype--uploaded">
        {renderHeader()}
        <div className="MU_logotype--uploaded__image_wrapper">
            <img className="MU_logotype--uploaded__image" src={props.path}/>
        </div>
    </div>
    )
}

UploadedView.propTypes = {
    path: PropTypes.string,
    text: PropTypes.string
}

export default UploadedView;


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/MediaUploaderSmall/UploadedView.jsx